"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18ZM7.53853 10.1647C7.2036 9.79792 6.6412 9.7781 6.28235 10.1204C5.92351 10.4627 5.90411 11.0376 6.23904 11.4043L8.34577 13.7114C8.69713 14.0962 9.29389 14.0962 9.64526 13.7114L14.561 8.32824C14.8959 7.96147 14.8765 7.38664 14.5176 7.04432C14.1588 6.702 13.5964 6.72182 13.2615 7.08859L8.99551 11.7602L7.53853 10.1647Z",
    fill: "#727B7F"
  }));
};